<template>
  <div class="list_container">
    <h5 class="text-center m1"><strong>Bestanden</strong></h5>
    <hr class="m-1">
    <a
      target="_blank"
      class="clickable_file"
      href="https://kleyn.sharepoint.com"
    >
      <div
        class="intranet_file"

      >
        De bestanden staan op Ask Katy!
      </div>
    </a>
  </div>
</template>

<script>
export default {

};
</script>